export default {
  setShowModal(state, status) {
    state.showModal = status;
  },
  setOrgShowModal(state, status) {
    state.showOrgModal = status;
  },
  setShowModalDraft(state, status) {
    state.showModalDraft = status;
  },
  setShowModalReply(state, status) {
    state.showModalReply = status;
  },
  setShowModalAboutUs(state, status) {
    state.showModalAboutUs = status;
  },
  setModalData(state, payload) {
    if (payload?.ownerId) {
      state.modalOrgData = payload;
    } else {
      state.modalData = payload;
    }
  },
  setReplyPostData(state, data) {
    state.replyPostData = data;
  },
  setQuotePostData(state, data) {
    state.quotePostData = data;
  },
};
